import { render, staticRenderFns } from "./TableForm8.vue?vue&type=template&id=1a247197&scoped=true"
import script from "./TableForm8.vue?vue&type=script&lang=ts"
export * from "./TableForm8.vue?vue&type=script&lang=ts"
import style0 from "./TableForm8.vue?vue&type=style&index=0&id=1a247197&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a247197",
  null
  
)

export default component.exports